import PropTypes from 'prop-types'
import { createContext, useContext, useMemo, useState, useEffect } from 'react'

import { useAuthContext } from './AuthProvider'
import { useInitialData } from '../services/user'

const UserContext = createContext(null)

export const useUserContext = () => useContext(UserContext)

const UserProvider = ({ children }) => {
  const { user } = useAuthContext()
  const {
    isLoading,
    data: userData,
    isError,
    error,
  } = useInitialData(user.cognitoId)
  const [centerCode, setCenterCode] = useState()
  const [centerHideId, setCenterHideId] = useState()

  useEffect(() => {
    if (Boolean(userData?.data.defaultCentreCode)) {
      setCenterCode(userData?.data.defaultCentreCode)
    }
  }, [userData])

  useEffect(() => {
    if (centerCode && userData?.data?.centres) {
      const matchingCentre = userData.data.centres.find(
        centre => centre.id === centerCode,
      )
      if (matchingCentre) {
        setCenterHideId(matchingCentre.hideId)
      }
    }
  }, [centerCode, userData?.data?.centres])
  const userContext = useMemo(
    () => ({
      isLoading,
      clientCode: userData?.data?.clientCode,
      clientId: userData?.data?.clientId,
      centres: userData?.data?.centres ?? [],
      statusList: userData?.data?.statusList,
      defaultCentreCode: userData?.data.defaultCentreCode,
      centerCode,
      setCenterCode,
      centerHideId,
      webUserCode: userData?.data.webUserCode,
      webUserEmail: userData?.data.webUserEmail,
      webUserName: userData?.data.webUserName,
      webUserPhone: userData?.data.webUserPhone,
      isFinancial: userData?.data.isFinancial,
      isMaster: userData?.data.isMaster,
      isError,
      error,
      auditData: {
        process_code: 'CLIENT-WEB',
        user_code: userData?.data?.webUserCode ?? '',
      },
    }),
    [
      isLoading,
      userData?.data?.clientCode,
      userData?.data?.clientId,
      userData?.data?.centres,
      userData?.data?.statusList,
      userData?.data?.defaultCentreCode,
      centerCode,
      setCenterCode,
      centerHideId,
      userData?.data?.webUserCode,
      userData?.data?.webUserEmail,
      userData?.data?.webUserName,
      userData?.data?.webUserPhone,
      userData?.data?.isFinancial,
      isError,
      error,
    ],
  )

  return (
    <UserContext.Provider value={userContext}>{children}</UserContext.Provider>
  )
}

UserProvider.propTypes = {
  children: PropTypes.node,
}

export default UserProvider
